import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { LayoutUtilsService } from '@app/core/_base/crud';
import { ModalCreateAttachmentCategoryComponent } from './modal-create-attachment-category/modal-create-attachment-category.component';
import { AttachmentCategory, Attachment, ApiResponse, PaginatedResponse, DialogCloseResult } from '../attachment-management/attachment.interface';

@Component({
  selector: 'meu-attachment-category-management',
  templateUrl: './attachment-category-management.component.html',
  styleUrls: ['./attachment-category-management.component.scss']
})
export class AttachmentCategoryManagementComponent implements OnInit {
  displayedColumns: string[] = ['Index', 'Name', 'Actions'];
  lstAllCategory: AttachmentCategory[] = [];
  total: number = 0;
  pageSize = 10;
  pageIndex = 1;
  filter: string = '';
  pageSizeOptions: number[] = [5, 10, 20, 100];
  public keyUp = new Subject<string>();
  private apiUrl = environment.backendhost + '/api/attachment_categories';

  constructor(
    private layoutUtilsService: LayoutUtilsService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private ref: ChangeDetectorRef,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit() {
    this.keyUp
      .pipe(
        map((event) => event),
        debounceTime(500)
      )
      .subscribe((value: string) => {
        this.pageIndex = 1;
        this.filter = 'name@=*' + value;
        this.getAllCategories();
      });
    this.getAllCategories();
  }

  getAllCategories() {
    const params: { Page: string; PageSize: string; Filters?: string } = {
      Page: this.pageIndex.toString(),
      PageSize: this.pageSize.toString()
    };
    if (this.filter) {
      params.Filters = this.filter;
    }

    this.http.get<ApiResponse<PaginatedResponse<AttachmentCategory>>>(this.apiUrl, { params }).subscribe(
      (res) => {
        if (res.success) {
          this.lstAllCategory = res.data.collection;
          this.total = res.data.total;
          this.ref.detectChanges();
        } else {
          this.toastr.error(res.message || 'Không thể tải danh sách thể loại');
        }
      },
      (error) => {
        this.toastr.error('Không thể tải danh sách thể loại');
      }
    );
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      this.getAllCategories();
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
    this.pageIndex = 1;
    this.getAllCategories();
  }

  openModalCategory(id: string | null) {
    const dialogRef = this.dialog.open(ModalCreateAttachmentCategoryComponent, {
      width: '600px',
      data: { id: id }
    });
    dialogRef.afterClosed().subscribe((result: DialogCloseResult | undefined) => {
      if (result != undefined && result.event != undefined) {
        if (result.event) {
          if (result.type == 'create') {
            this.toastr.success('Tạo mới thể loại thành công');
            this.getAllCategories();
          } else {
            this.toastr.success('Chỉnh sửa thể loại thành công');
            this.getAllCategories();
          }
        }
      }
    });
  }

  deleteCategory(id: string, name: string) {
    const checkUrl = environment.backendhost + '/api/attachments';
    this.http.get<ApiResponse<PaginatedResponse<Attachment>>>(
      checkUrl, { params: { Page: '1', PageSize: '1', Filters: `attachment_category_id==${id}` } }
    ).subscribe(
      (checkRes) => {
        if (checkRes.success && checkRes.data && checkRes.data.total > 0) {
          this.toastr.error(
            `Không thể xóa thể loại "${name}" vì còn ${checkRes.data.total} tài liệu bên trong. Vui lòng xóa hoặc chuyển tài liệu sang thể loại khác trước.`,
            'Không thể xóa',
            { timeOut: 5000 }
          );
          return;
        }

        const _title = 'Xóa thể loại';
        const _description = 'Bạn có chắc chắn muốn xóa thể loại ' + name + '?';
        const _waitDesciption = 'Đang xóa...';

        const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
        dialogRef.afterClosed().subscribe((res: boolean) => {
          if (!res) {
            return;
          }

          this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`).subscribe(
            (response) => {
              if (response.success) {
                    // Refresh list on success (no snackbar shown)
                    this.getAllCategories();
                  } else {
                this.toastr.error(response.message || 'Không thể xóa thể loại');
              }
            },
            () => {
              this.toastr.error('Có lỗi xảy ra khi xóa thể loại');
            }
          );
        });
      },
      () => {
        this.toastr.error('Không thể kiểm tra tài liệu trong thể loại');
      }
    );
  }

  goBack() {
    this.router.navigate(['/admin/attachment-management']);
  }
}
